import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'as-user-icon',
  templateUrl: './user-icon.component.html',
  styleUrls: ['./user-icon.component.scss']
})
export class UserIconComponent implements OnInit {

  @Input() name

  constructor() { }

  ngOnInit() {

  }

}
